import React, { Component } from 'react'
import { setAdminPage, setPreloadScreen } from '../../action/action'
import { connect } from 'react-redux'
import { heightFix } from '../../JS/heightFix'

class preload extends Component {
    constructor(props) {
        super(props);
        this.time = 0
        this.state = {
            logoClickCount: 0,
            eventTouch: "click"
        }
    }

    headingClick = (event) => {
        if (this.state.eventTouch === event.type) {
            console.log("headingClick");
            window.clearTimeout(this.time);
            this.setState({ logoClickCount: this.state.logoClickCount + 1 });
            this.time = window.setTimeout(() => {
                this.setState({ logoClickCount: 0 });
            }, 2000);
            if (this.state.logoClickCount >= 5) {
                //console.log("we are in admin access.");
                this.props.setAdminPage(true);
                this.props.setPreloadScreen(false);
            }
        }
        if (event.type === "touchend") {
            this.setState({ eventTouch: "touchend" });
        }
    }

    render() {
        return (
            <div class="overlay preloader"
                style={{overflow: "scroll"}}
            //onClick={this.headingClick} onTouchEnd={this.headingClick}
            >
                <div class="preload-header"></div>
                <div class="preload-body">
                    <div class="preload-container">
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-button"></div>
                    </div>
                    <div class="preload-container">
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-button"></div>
                    </div>
                    <div class="preload-container">
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-button"></div>
                    </div>
                    <div class="preload-container">
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-text"></div>
                        <div class="preload-button"></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    null,
    {
        setAdminPage,
        setPreloadScreen
    }
)(preload);